;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();export {
  /** @deprecated Use `@qogita/ui/v2/qogita-logo` instead. */
  QogitaLogoContained,
  /** @deprecated Use `@qogita/ui/v2/qogita-logo` instead. */
  QogitaLogoEmblem,
  /** @deprecated Use `@qogita/ui/v2/qogita-logo` instead. */
  QogitaLogoOutlined,
  /** @deprecated Use `@qogita/ui/v2/qogita-logo` instead. */
  QogitaLogoWordmark,
} from '../../v2/qogita-logo'
